import React from 'react';
import emDesenvolvimentoImg from '../../../assets/static_img/em-desenvolvimento.png';
import logoCarmine from '../../../assets/static_img/logo_carmine.svg';
import css from './inativarsite.module.css';

export default function SiteEmDesenvolvimento() {
  return (
    <div className={css.divMaior}>
      <img src={emDesenvolvimentoImg} alt="Em Desenvolvimento" className={css.mainImage} />

      <div className={css.conteudoTexto}>
        <h1 className={css.titleText}>Site em Desenvolvimento</h1>
        <p className={css.descriptionText}>
          Neste momento, o nosso site está em desenvolvimento, mas continuamos disponíveis para o
          atender. Agradecemos o interesse e convidamo-lo a voltar em breve.<br></br>
          Obrigado pela compreesão.
        </p>
      </div>
      <hr className={css.dividerLine} />
      <div className={css.conteudoImg}>
        <p className={css.descriptionText}>Desenvolvido por:</p>
        <img src={logoCarmine} alt="Logo Carmine" className={css.logoImageDev} />
      </div>
    </div>
  );
}
